/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgUpOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 17 16"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.52 10.791a.5.5 0 0 1-.707 0L8.498 6.478 4.186 10.79a.5.5 0 0 1-.707-.707l5.02-5.02 5.02 5.02a.5.5 0 0 1 0 .707Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgUpOutlined)
export default Memo
